import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }
  public write(key: string, value: any) {
    try {
      if (value) {
        value = JSON.stringify(value);
      }
      localStorage.setItem(key, value);
    } catch (e) {
      // TODO handle error
      console.log('StorageService write error: ', e)
    }
  }

  public read<T>(key: string): T {
    const value: string = localStorage.getItem(key);
    let res = null;
    if (value && value !== 'undefined' && value !== 'null') {
      try {
        res = <T>JSON.parse(value);
      } catch {
        res = value;
      }
    }

    return res;
  }

  public readWithoutJsonParse<T>(key: string): T {
    const value: string = localStorage.getItem(key);
    let res = null;
    if (value && value !== 'undefined' && value !== 'null') {
      res = value;
    }

    return res;
  }

  public clearLocalStorageExceptCommProjects() {
    const itemsToRemove = []
    for (var i = 0; i < localStorage.length; i++) {
      if (!localStorage.key(i).startsWith('NaCommProjects') &&
      !localStorage.key(i).startsWith('na-commercial-defaultdoc')) {
        itemsToRemove.push(localStorage.key(i));
      }
    }

    for (var j = 0; j < itemsToRemove.length; j++) {
      localStorage.removeItem(itemsToRemove[j]);
    }
  }

  public remove<T>(key: string) {
    try{
      localStorage.removeItem(key);
    }catch (e){
      console.log("StorageService remove error ", e)
    }
    
  }

}